export function parseLocaleNumber(stringNumber, locale = navigator.language || 'en-US') {
  const formatter = new Intl.NumberFormat(locale)
  const parts = formatter.formatToParts(12345.6)
  const groupSymbol = parts.find(p => p.type === 'group')?.value || ','
  const decimalSymbol = parts.find(p => p.type === 'decimal')?.value || '.'

  // Normalize number string (replace locale-specific group separators)
  const normalized = `${stringNumber}`
    .replace(new RegExp(`\\${groupSymbol}`, 'g'), '') // Remove thousands separator
    .replace(new RegExp(`\\${decimalSymbol}`), '.')  // Convert decimal separator to standard "."

  return Number(normalized)
}

export function formatNumberToLocale(number, minimumFractionDigits = 0, maximumFractionDigits = 2, locale = navigator.language) {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits
  }).format(number)
}